import React, {Fragment} from 'react';
import {createUseStyles} from 'react-jss';
import Select from 'react-select';

import {desktopSelectorStyles} from '../../common-styles/selector-style';
import {
  CHANGE_CURRENCY,
  CLOSE_SELECT,
  OPEN_SELECT,
  SELECT_CURRENCY
} from '../../utils/action-types';
import {COLORS} from '../../utils/style-variables';

import {currencySelectorHoc} from './currency-selector-hoc';
import {Radio} from './radio';

const useStyles = createUseStyles({
  radioButton: {
    display: 'inline-block',
    padding: '10px 14px',
    marginRight: 8,
    cursor: 'pointer',
    position: 'relative',
    fontSize: '15px',
    lineHeight: '17px',
    textAlign: 'center',
    color: COLORS.blackColor,
    '&:hover': {
      backgroundColor: '#F6F7F8'
    },
    '&:active': {
      backgroundColor: '#F6F7F8',
      color: COLORS.blue100Color
    }
  },
  radioInput: {
    display: 'none',
    '&:checked + span': {
      color: COLORS.blue100Color,
      borderColor: COLORS.blue100Color,
      backgroundColor: 'rgba(0, 83, 148, 0.1)',
      zIndex: 1
    }
  },
  inputValue: {
    extend: 'radioInput',
    '&[value="all"]': {
      '& + span': {
        paddingRight: 30,
        '&:after': {
          content: '""',
          borderStyle: 'solid',
          borderWidth: '2px 2px 0 0',
          borderColor: COLORS.greyColor,
          display: 'inline-block',
          position: 'absolute',
          width: 8,
          height: 8,
          top: 'calc(50% - 6px)',
          right: 10,
          transform: 'rotate(135deg)',
          verticalAlign: 'top'
        },
        '&.open': {
          '&:after': {
            top: 'calc(50% - 4px)',
            transform: 'rotate(-45deg)'
          }
        }
      }
    }
  },
  inputName: {
    extend: 'radioButton',
    borderRadius: '2px'
  },
  dropDownWrapper: {
    display: 'inline-block',
    position: 'relative'
  },
  selectOtherCurrency: {
    position: 'absolute',
    width: 280,
    marginTop: 4,
    padding: 8,
    backgroundColor: '#fff',
    borderRadius: 2,
    boxShadow: '0px 2px 6px rgba(36, 36, 36, 0.3)',
    zIndex: 3
  },
  blanket: {
    bottom: 0,
    left: 0,
    top: 0,
    right: 0,
    position: 'fixed',
    zIndex: 1
  }
});

const buttonsTemplate = (buttonsList, radio, radioHandler) => {
  const classes = useStyles();

  return buttonsList.map(item => (
    <Radio
      key={item}
      value={item}
      name={item}
      group='currency-name'
      classes={classes}
      radio={radio}
      setRadio={radioHandler}
    />
  ));
};

const desktopCurrencies = ({listData, changeCurrency, state: {open, radio, value}}) => {
  const classes = useStyles();
  const desktopButtonsList = ['USD', 'EUR', 'RUB'];
  const desktopSelectorList = listData.map(currencyGroup => ({
    label: currencyGroup.label,
    options: currencyGroup.options.filter(({value: currencyCode}) => !desktopButtonsList.includes(currencyCode))
  }));

  const radioHandler = val => {
    if (val === 'all') {
      changeCurrency({type: OPEN_SELECT});
    } else {
      changeCurrency({
        type: CHANGE_CURRENCY,
        payload: {label: val, value: val}
      });
    }
  };

  const onSelectChange = selected => {
    changeCurrency({
      type: SELECT_CURRENCY,
      payload: selected
    });
  };

  return (
    <div>
      {buttonsTemplate(desktopButtonsList, radio, radioHandler)}
      <div className={classes.dropDownWrapper}>
        <Radio
          value='all'
          name={desktopButtonsList.includes(value.value) ? 'Другая валюта' : value.label}
          group='currency-name'
          classes={classes}
          radio={radio}
          setRadio={radioHandler}
          open={open}
        />

        {open ?
          <Fragment>
            <div className={classes.selectOtherCurrency}>
              <Select
                autoFocus
                components={{DropdownIndicator: null, IndicatorSeparator: null}}
                backspaceRemovesValue={false}
                controlShouldRenderValue={false}
                hideSelectedOptions={false}
                isClearable={false}
                menuIsOpen
                onChange={onSelectChange}
                options={desktopSelectorList}
                noOptionsMessage={() => 'Не найдено'}
                placeholder='Название валюты'
                tabSelectsValue={false}
                styles={desktopSelectorStyles}
                value={value}
              />
            </div>
            <div
              className={classes.blanket}
              onClick={() => changeCurrency({type: CLOSE_SELECT})}
            />
          </Fragment>
          : null}
      </div>
    </div>
  );
};

export default currencySelectorHoc(desktopCurrencies);
